class PlayerError extends Error {
  cause?: ErrorCause | Error | unknown;

  constructor(
    message: string | Record<string, unknown> | ErrorMessage,
    { cause }: { cause?: ErrorCause | Error | unknown } = {}
  ) {
    super(typeof message === 'string' ? message : JSON.stringify(message));
    this.name = 'PlayerError';
    this.cause = cause;
  }
}

export class AdError extends PlayerError {}

export enum ErrorMessage {
  FAIL_TO_CREATE_PLAYER = 'Fail to create player',
  FAIL_TO_LOAD_GOOGLE_IMA_SDK = 'Fail to load Google IMA SDK',
  FAIL_TO_CREATE_IMA_INSTANCE_DUE_TO_NOT_LOADED_GOOGLE_IMA_YET = 'Fail to create IMA instance due to not loaded google ima yet',
  FAIL_TO_CREATE_IMA_INSTANCE_DUE_TO_UNABLE_TO_FIND_INITIATOR = 'Fail to create IMA instance due to unable to find initiator',
  FAIL_TO_GET_SRC_OF_PARSED_VCP_INFO_FROM_VIDEO_OBJECT_OR_VIDEOID = 'Fail to get src of parsed VCP info from video object or videoId',
  FAIL_TO_FIND_CONTAINER_ELEMENT_TO_INITIATE_VIDEO_PLAYER = 'Fail to find container element to initiate video player',
  VIDEO_JS_ERROR = 'video.js emitted error, check the cause for the original error',
  // ad related
  AD_ERROR_FOUND = 'Ad error found',
}

export enum ErrorCause {}

export default PlayerError;
